import api from './api'
import Cookies from 'js-cookie'

export async function login(username, password) {

        api.post('/api/auth/signin', {
            username: username,
            password: password
        }).then(res => {
            if (res.data) {
                // alert('Đăng nhập thành công!')
                // console.log(res)
                Cookies.set('token', res.data.token)
                window.location.href = '/mobile-menu'
            } else {
                alert('Sai tài khoản hoặc mật khẩu!')
            }
        })
}

export function logout() {
    // Clear token from cookie
    Cookies.remove('token')

    // Redirect to login page
    window.location.href = '/login'
}

